import styled from "styled-components";

export const RechargeRadioWrapper = styled.div`
  margin-top: 16px;
`;

export const RechargeRadioList = styled.div`
  margin-top: 6px;
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
`;

export const RadioContent = styled.div`
  display: flex;
  align-items: center;
  svg {
    margin-right: 8px;
  }
  .price {
    margin: 0 5px;
  }
`;

export const RechargeRadioCircle = styled.div`
  width: 14px;
  height: 14px;
  border-radius: 50%;
  border: 1px solid rgba(255, 255, 255, 0.2);
  transition: all 0.3s;
  margin-right: 7px;
`;

export const RechargeRadio = styled.div`
  background: #212327;
  display: flex;
  align-items: center;
  min-width: 224px;
  height: 40px;
  padding: 0 12px;
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 6px;
  cursor: pointer;
  background: #292b2f;
  &.active {
    border: 2px solid #f3512b;
    background: unset;
    ${RechargeRadioCircle} {
      width: 14px;
      height: 14px;
      border-radius: 50%;
      background-color: #f3512b;
      position: relative;
      z-index: 1;
      ::before {
        content: "";
        display: block;
        width: 8px;
        height: 8px;
        border-radius: 50%;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
        margin: auto;
        background-color: #ffffff;
        position: absolute;
        z-index: 2;
      }
    }
  }
`;
